import {listVehicleInterestTypes}     from './types';

export const listVehicleInterest = (state = {vehicleIds: [], loading: false, error: ''}, action) => {
    switch (action.type) {
        case listVehicleInterestTypes.FETCH_SUCCESS:
            return {
                ...state,
                vehicleIds: action.payload.vehicleIds,
            };
        case listVehicleInterestTypes.ADD:
            return {
                ...state,
                vehicleIds: [...state.vehicleIds, action.payload.vehicleId],
            };
        case listVehicleInterestTypes.REMOVE:
            return {
                ...state,
                vehicleIds: state.vehicleIds.filter(id => id !== action.payload.vehicleId),
            };
        case listVehicleInterestTypes.POST_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
            };
        case listVehicleInterestTypes.POST_SUCCESS:
            return {
                ...state,
                loading: false,
                error: '',
                lastUpdate: action.receivedAt
            };
        case listVehicleInterestTypes.POST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
            case listVehicleInterestTypes.ERROR_CLEAR:
                return {
                    ...state,
                    error: '',
                };
        default:
            return state;
    }
}
